module.exports = __webpack_public_path__ + "static/testi-1-6-2c4ce35d2c32be79c5daf0606dccf93f.jpg";